import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from "axios";
import "./assets/css/custom.css";
import { BrowserRouter } from 'react-router-dom';
import App from './App';

axios.defaults.withCredentials = true;

const defaultFetch = window.fetch.bind(window);
window.fetch = (input: RequestInfo | URL, init: RequestInit = {}) =>
  defaultFetch(input, { credentials: "include", ...init });



ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>

  </React.StrictMode>
)



